// src/components/LogoIcon.js
import React, { useState, useEffect } from 'react';

const LogoIcon = () => {
  const [svgContent, setSvgContent] = useState('');

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/img/logo_icon_a.svg`)
      .then(response => response.text())
      .then(svgText => {
        // Modifica el tamaño del SVG (ej: 40x40)
        const resizedSvg = svgText
          .replace(/width="[^"]*"/, 'width="60"')
          .replace(/height="[^"]*"/, 'height="60"');
        setSvgContent(resizedSvg);
      })
      .catch(error => console.error("Error loading SVG:", error));
  }, []);

  return (
    <div 
      className="toggle-icon" 
      dangerouslySetInnerHTML={{ __html: svgContent }} 
    />
  );
};

export default LogoIcon;